<div style="background: linear-gradient(180deg, #077A7D, #7AE2CF);">

  <header class="text-center py-3">
    <h1 style="color:#ffffff; font-size: 28px; font-weight: bold; margin: 0;">SRI PARASAKTHI VIDYALAYA CBSE COURTALLAM</h1>
    <!-- <p style="color: white; font-size: 14px; margin: 5px 0 0;"></p> -->
        <p style="color: white; font-size: 14px; margin: 5px 0 0;">Affiliated to CBSE Under the Management of H.R & C.E Department TN Gov</p>
  </header>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="navbarNavDropdown" class="collapse navbar-collapse">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a routerLink="/home-page" class="nav-link" style="color: #ffffff;" routerLinkActive="active">Home</a>
          </li>
          <li class="nav-item">
            <a routerLink="/about-us" class="nav-link" style="color: #ffffff;" routerLinkActive="active">About Us</a>
          </li>
          <li class="nav-item">
            <a routerLink="/verticals" class="nav-link" style="color: #ffffff;" routerLinkActive="active">Our-Management</a>
          </li>
          <li class="nav-item">
            <a routerLink="/gallery" style="color: #ffffff;" class="nav-link" routerLinkActive="active">Gallery</a>
          </li>
          <li class="nav-item">
            <a routerLink="/contact-us" style="color: #ffffff;" class="nav-link" routerLinkActive="active">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

</div>